import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'

import { Headerbar, Loader, Select } from '../../Reusable'
import './OrderingBox.scss';

import { Fire } from '../../../services'

import FadeIn from 'react-fade-in';

import { SortableContainer, SortableElement } from 'react-sortable-hoc';

type SelectionProps = {
  item: any;
  disabled?: boolean;
}
const SelectionItem = SortableElement((props: SelectionProps) => {
  const item = props.item
  const impressions = item.impressions_count || 0
  const reach = item.impressions_count_reach || 0
  return (
    <div key={'item-' + item.index} className="select-item">
      <div className="select-rank">{'#' + (item.index + 1)}</div>
      <img alt="Preview" className="select-preview" src={item.pictures && item.pictures.length ? item.pictures[0] : ''} />
      <div className="select-veil">
        <div className="select-name">
          <span>{item.name}</span>
        </div>
        <div className="select-more">
          <span>{impressions + ' impr. - ' + reach + ' reach'}</span>
        </div>
      </div>
    </div>
  )
})

type SelectionsProps = {
  items: any[];
  disabled?: boolean;

  onRemove: (index: number) => void;
}
const SelectionList = SortableContainer((props: SelectionsProps) => {
  return (
    <div className="ordering-list">
      {props.items.map((item, index) => (
        <div key={index} style={{position: 'relative'}}>
          <SelectionItem
            item={{...item, index: index}}
            key={index}
            index={index}
            disabled={props.disabled}
            />
          { !props.disabled &&
            <div className="select-close" onClick={(e) => props.onRemove(index)}><i className="fa fa-close"></i></div>
          }
        </div>
      ))}
    </div>
  )
});

interface Props {
  title: string;

  onFetch: () => Promise<any[]>
  onSave: (items: any[]) => void;
}
const OrderingBox: React.FC<Props> = (props) => {
  
  const [items, setItems] = React.useState<any[]>([])

  const refresh = async () => {
    setLoading(true)
    try {
      setItems(await props.onFetch())
    } catch (err) {
      console.warn(err)
    }
    setLoading(false)
  }

  React.useEffect(() => {
    refresh()
  }, [])

  const [selectedItems, setSelectedItems] = React.useState<any[]>([])
  const [availableItems, setAvailableItems] = React.useState<any[]>([])
 
  const [loading, setLoading] = React.useState(false)
  const [changed, setChanged] = React.useState(false)
 
  const [input, setInput] = React.useState('')

  const reset = () => {
   setSelectedItems([...items]
      .filter(item => item.featured > 0)
      .sort((a, b) => a.featured > b.featured ? 1 : -1))
    setAvailableItems(items.filter((item) => !(item.featured > 0)))
    setChanged(false)
  }

  React.useEffect(() => {
    reset()
  }, [items])

  const select = (id: string) => {
    setInput(id)
    
    for (let i = 0; i < availableItems.length; ++i) {
      const item = availableItems[i]
      if (item.id === id) {
        const itemsCount = selectedItems.length === 0 ? 0 : selectedItems[selectedItems.length - 1].featured
        item.changed = 1 + (itemsCount)
        item.featured = item.changed

        availableItems.splice(i, 1)

        setSelectedItems([...selectedItems, item])
        setAvailableItems([...availableItems])
        setChanged(true)
        break
      }
    }
  }

  const save = async () => {
    setLoading(true)
    try {
      const results = selectedItems.concat(availableItems)
      props.onSave(results)
    } catch (err) {
      console.warn(err)
    }
    setLoading(false)
    setChanged(false)
  }

  const onSortEnd = ({oldIndex, newIndex}) => {
    const newSelected: any[] = []
    if (oldIndex < newIndex) {
      // From left to right
      for (let i = 0; i <= newIndex; ++i) {
        if (i !== oldIndex)
          newSelected.push(selectedItems[i])
      }
      newSelected.push(selectedItems[oldIndex])
      for (let i = newIndex + 1; i < selectedItems.length; ++i)
        newSelected.push(selectedItems[i])
    } else {
      // From right to left
      for (let i = selectedItems.length - 1; i >= newIndex; --i) {
        if (i !== oldIndex)
          newSelected.push(selectedItems[i])
      }
      newSelected.push(selectedItems[oldIndex])
      for (let i = newIndex - 1; i >= 0; --i)
        newSelected.push(selectedItems[i])
      newSelected.reverse()
    }
    for (let i = 0; i < newSelected.length; ++i) {
      newSelected[i].featured = i + 1
      newSelected[i].changed = newSelected[i].featured
    }
    setSelectedItems(newSelected)
    setChanged(true)
  };

  const removeItem = (idx: number) => {
    const confirm = window.confirm('Êtes-vous sûr de vouloir supprimer cet élément ?')
    if (!confirm)
      return;
    const item = selectedItems[idx]
    item.changed = 0
    item.featured = 0

    for (let i = idx; i < selectedItems.length; i++) {
      const item = selectedItems[i]
      item.featured -= 1
      item.changed = item.featured
    }
    selectedItems.splice(idx, 1)

    setSelectedItems([...selectedItems])
    setAvailableItems([...availableItems, item])
    setChanged(true)
  }

  return (
    <div className="card">
      <div className="card-header">
        <div className="row spaced-row">
          <h3 className="card-title">{props.title}</h3>

          <Select
            value={input}
            onChange={(val) => select(val)}
            options={availableItems.map((item) => ({ value: item.id, label: item.name }))}
            wrapperStyle={{width: 200}}
            />
        </div>
      </div>

      <div className="card-body">
        <div className="select-items">
          <SelectionList
            axis="y"
            lockAxis="y"
            items={selectedItems}
            onSortEnd={onSortEnd}
            onRemove={removeItem}
            />
        </div>

        { changed &&
          <div className="">
            <div className="text-danger" style={{cursor: 'pointer'}} onClick={reset}>Annuler</div>
            <div className="text-primary" style={{cursor: 'pointer'}} onClick={save}>Sauvegarder</div>
          </div>
        } 
        
      </div>
    </div>
  );
}

export default OrderingBox